import { Component, OnInit } from '@angular/core';
import { LevelMasterService } from './level-master.service';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-level-master',
  templateUrl: './level-master.component.html',
  styleUrls: ['./level-master.component.css'],
})
export class LevelMasterComponent implements OnInit {
  isLoading = new BehaviorSubject<boolean>(false);
  displayedColumns: string[] = [
    'SNo',
    'createdAt',
    'interest_level',
    'status',
    'updatedAt',
    'action',
  ];
  bucketurl = environment.bucketUrl;
  public ELEMENT_DATA: any[] = [];
  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;
  public selectedId: number | null = null;
  levelMaster: FormGroup;
  dataSource = new MatTableDataSource<any>(this.ELEMENT_DATA);

  constructor(
    private levelMasterService: LevelMasterService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) {
    this.levelMaster = this.fb.group({
      status: ['', Validators.required],
      interest_level: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.getLevelMasterData();
  }

  back() {
    this.clearForm();
    this.isCreate = false;
    this.isEdit = false;
    this.getLevelMasterData();
  }

  get f() {
    return this.levelMaster.controls;
  }

  clearForm() {
    this.submitted = false;
    this.levelMaster.patchValue({
      status: '',
      interest_level: '',
    });
    this.selectedId = null;
  }

  getLevelMasterData() {
    this.isLoading.next(true);
    this.levelMasterService.getLevelMaster().subscribe(
      (response) => {
        this.ELEMENT_DATA = response.body.data;
        this.dataSource.data = this.ELEMENT_DATA;
        this.isLoading.next(false);
      },
      (error) => {
        this.isLoading.next(false);
      }
    );
  }

  edit(element: any) {
    this.isEdit = true;
    this.isCreate = false;
    this.selectedId = element.id;
    this.levelMaster.patchValue({
      status: element.status ? 1 : 0,
      interest_level: element.interest_level,
    });
  }

  onSubmit() {
    this.submitted = true;

    if (this.levelMaster.invalid) {
      return;
    }

    this.isLoading.next(true);

    if (this.isEdit) {
      if (this.selectedId !== null) {
        this.levelMasterService
          .updateLevelMaster(this.selectedId, this.levelMaster.value)
          .subscribe(
            (response) => {
              let responseData = response.body;
              if (responseData.responseCode == 200) {
              this.toastr.success('Level Master updated successfully');
              this.clearForm();
              this.isEdit = false;
              this.getLevelMasterData();
              this.isLoading.next(false);
              }else { 
                this.isLoading.next(false);
                this.toastr.error(responseData.responseMessage)
              }
            },
            (error) => {
              this.toastr.error('Error updating Level Master');
              this.isLoading.next(false);
            }
          );
      }
    } else {
      this.levelMasterService
        .createLevelMaster(this.levelMaster.value)
        .subscribe(
          (response) => {
            let responseData = response.body;
            if (responseData.responseCode == 200) {
            this.toastr.success('Level Master created successfully');
            this.clearForm();
            this.isCreate = false;
            this.getLevelMasterData();
            this.isLoading.next(false);
            } else {
              this.isLoading.next(false);
              this.toastr.error(responseData.responseMessage)
            }
          },
          (error) => {
            this.toastr.error('Error creating Level Master');
            this.isLoading.next(false);
          }
        );
    }
  }

  public searchInput = new FormControl("");
  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const interest_level = data.interest_level.toLowerCase().includes(filter);
      return interest_level;
    };
      this.dataSource.filter = filterValue;
  }
   clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }
}
